import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFuriousEmojiSecondary from './svgs/FuriousEmojiSecondary.js';
import SvgFuriousEmoji from './svgs/FuriousEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var furiousEmoji = (props => useIcon(SvgFuriousEmoji, SvgFuriousEmojiSecondary, props));

export { furiousEmoji as default };
